import React, { useEffect, useState } from "react";
import { FaAndroid, FaMobileAlt, FaShieldAlt, FaHeadset, FaBolt } from "react-icons/fa";
import apiInstance from "../utils/axios";

function DownloadApp() {

  const [current, setCurrent] = useState(null);

  useEffect(() => {
    fetchCurrent();
  }, []);

  const fetchCurrent = async () => {
    try {
      const res = await apiInstance.get("/api/app/version");
      setCurrent(res.data);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-r from-[#4b0000] via-[#5c0a0a] to-[#3a0000] text-white">

      <div className="max-w-6xl mx-auto px-6 py-24 text-center">

        {/* Title */}
        <h1 className="text-5xl md:text-6xl font-bold mb-6">
          Online Entertainment App
        </h1>

        {/* Description */}
        <p className="text-gray-300 max-w-2xl mx-auto text-lg mb-10">
          Sai Matka Official is a modern Android application designed for digital
          entertainment and interactive experiences. Built with performance,
          simplicity, and user convenience in mind.
        </p>

        {/* Download Button */}
        <a
          href={current?.apk_url}
          className="inline-flex items-center gap-3 bg-red-500 hover:bg-red-600 text-white px-8 py-4 rounded-full text-lg font-semibold shadow-lg transition"
        >
          <FaAndroid />
          Get Android App
        </a>

        {/* Feature Cards */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mt-20">

          {/* Card 1 */}
          <div className="bg-[#5c0a0a]/60 border border-red-400/20 rounded-xl p-6 text-center backdrop-blur hover:scale-105 transition">

            <FaMobileAlt className="text-red-400 text-3xl mx-auto mb-4" />

            <h3 className="font-semibold text-lg mb-2">
              Android Optimized
            </h3>

            <p className="text-gray-300 text-sm">
              Smooth performance and optimized design for Android devices.
            </p>

          </div>

          {/* Card 2 */}
          <div className="bg-[#5c0a0a]/60 border border-red-400/20 rounded-xl p-6 text-center backdrop-blur hover:scale-105 transition">

            <FaShieldAlt className="text-red-400 text-3xl mx-auto mb-4" />

            <h3 className="font-semibold text-lg mb-2">
              Secure Platform
            </h3>

            <p className="text-gray-300 text-sm">
              Designed with security best practices and user safety in mind.
            </p>

          </div>

          {/* Card 3 */}
          <div className="bg-[#5c0a0a]/60 border border-red-400/20 rounded-xl p-6 text-center backdrop-blur hover:scale-105 transition">

            <FaHeadset className="text-red-400 text-3xl mx-auto mb-4" />

            <h3 className="font-semibold text-lg mb-2">
              24/7 Assistance
            </h3>

            <p className="text-gray-300 text-sm">
              Dedicated support to help users with app-related queries.
            </p>

          </div>

          {/* Card 4 */}
          <div className="bg-[#5c0a0a]/60 border border-red-400/20 rounded-xl p-6 text-center backdrop-blur hover:scale-105 transition">

            <FaBolt className="text-red-400 text-3xl mx-auto mb-4" />

            <h3 className="font-semibold text-lg mb-2">
              Fast & Lightweight
            </h3>

            <p className="text-gray-300 text-sm">
              Quick loading experience with a lightweight application size.
            </p>

          </div>

        </div>

        {/* Disclaimer */}
        <div className="mt-16 text-gray-400 text-sm max-w-2xl mx-auto">
          <p className="font-semibold mb-2">Disclaimer:</p>
          This application is intended for entertainment purposes only.
          No real-money gaming or betting is promoted. Access is restricted
          to users aged 21 years and above.
        </div>

      </div>

    </div>
  );
}

export default DownloadApp;